const getters = {
  userInfo: (state) => state.user.userInfo, // 登录用户个人信息
  cartCount: (state) => state.cart.cartList.length,
  cartList: (state) => state.cart.cartList,
  messageCount: (state) => state.message.messageCount,
  hasMember: (state) => state.user?.userInfo?.vip_info?.is_vip || false  // 当前登录用户是否为会员
}

export default getters
